
  import { Vue, Component, Prop } from "vue-property-decorator";
  import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";

  import GET_PROJECT_CITIES from "@/apollo/autocomplete-queries/GetProjectCities.gql";
  import DropdownOption from "@/entities/DropdownOption";
  import { Query_RootProjectArgs } from "@/generated/graphql";
  

  @Component({
    components: {
      DropdownFilter,
    },
    apollo: {
      projectCities: {
        query: GET_PROJECT_CITIES,
        variables() {
          return this.cityAutocompleteFilter;
        },
        update(data) {
          return data.project;
        },
        skip() {
          return !this.projectCitySearchString;
        },
      },
    },
  })

  export default class ProjectCitiesMultiselect extends Vue {
    @Prop({required: true, type: Array}) value!: DropdownOption[];
    @Prop({ type: String, default: "" }) readonly getcontainerStyle?: string;
    @Prop({ type: Array, default: () => [] }) country!: string[];
    @Prop({ type: Array, default: () => [] }) state!: string[];
    @Prop({ type: String, default: "Select city" }) readonly placeholder!: string;

    projectCities: DropdownOption[] = [];
    projectCitySearchString = "";

    get cityOptions(): DropdownOption[] {
      return this.projectCities;
    }

    get mappedProjectCityValue(): String[] {
      return this.value?.map((item) => item.name);
    }

    get cityAutocompleteFilter():Query_RootProjectArgs {
      const conditions: any[] = [
        {
          city: {
            _ilike: `%${this.projectCitySearchString}%`,
          },
        },
        {
          city: {
            _neq: ""
          }
        }
      ];

      if (this.mappedProjectCityValue.length) {
        conditions.push(
          {
            city: {
              _nin: this.mappedProjectCityValue,
            },
          },
        );
      }

      if (this.country.length) {
        conditions.push({
          country: {
            _in: this.country,
          }
        })
      }

      if (this.state.length) {
        conditions.push({
          state: {
            _in: this.state,
          }
        })
      }
      return {
        where: { _and: conditions },
        limit: 5,
      };
    }

    handleInput(val: DropdownOption[]) {
      this.$emit("input", val);
    }

    handleSearch(val: string) {
      this.projectCitySearchString = val;
    }
  }
